module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('router-link', {
    staticClass: "fl-button grey",
    attrs: {
      "to": {
        path: '/gateways/'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])], 1), _vm._v(" "), _c('h1', [_vm._v("Gateway")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "name",
      "label": "Megnevezés",
      "errors": _vm.errors,
      "name": "name"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('comboboxV2', {
    attrs: {
      "id": "building_id",
      "label": "Épület",
      "errors": _vm.errors,
      "name": "building_id",
      "options": _vm.buildings,
      "change": _vm.buildingChange
    },
    model: {
      value: (_vm.form.building_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "building_id", $$v)
      },
      expression: "form.building_id"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "process_name",
      "label": "Process név",
      "errors": _vm.errors,
      "name": "name"
    },
    model: {
      value: (_vm.form.process_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "process_name", $$v)
      },
      expression: "form.process_name"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "address",
      "label": "Cím",
      "errors": _vm.errors,
      "name": "name"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "port",
      "label": "Port",
      "errors": _vm.errors,
      "name": "name"
    },
    model: {
      value: (_vm.form.port),
      callback: function($$v) {
        _vm.$set(_vm.form, "port", $$v)
      },
      expression: "form.port"
    }
  }), _vm._v(" "), _c('textareabox', {
    attrs: {
      "id": "comment",
      "label": "Megjegyzés",
      "errors": _vm.errors,
      "name": "comment"
    },
    model: {
      value: (_vm.form.comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "comment", $$v)
      },
      expression: "form.comment"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-325c1ab0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/gateway.vue
// module id = 292
// module chunks = 0